<template>
  <div class="oe-list-warp">
    <!-- 头部搜索导航栏 -->
    <!-- <div class="navigation">
      <div class="navigation-content">
        <div class="logo-left">
          <img
            class="navigation-logo"
            src="../../assets/img/aoweiLogo.png"
            @click="returnBenBen"
          />
          <router-link to="/" class="return-benben">返回EPC首页</router-link>
        </div>
        <div class="navigation-search" id="search-form">
          <el-input
            prefix-icon="el-icon-search"
            placeholder="请输入VIN码"
            maxlength="17"
            size="small"
            class="input-with-select"
            v-model="vin"
            @keyup.enter.native="vinCodeSearch()"
            @focus="recordShow = true"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="vinCodeSearch()"
            ></el-button>
          </el-input>
          <div
            class="bdsug bdsugbg"
            id="bdsugbg"
            v-show="recordShow && recordList && recordList.length > 0"
          >
            <ul>
              <li
                v-for="(item, index) in recordList"
                :key="index"
                @click="clickRecord(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <span class="name-font"
            ><a @click="carInfoDialog">查看车型详情 >></a></span
          >
          <div class="search-bar-selection">
            <span class="vehicle-name">车型：{{ modelCname }}</span>
            <a @click="carTypeDialog">手动选车车型>></a>
          </div>
        </div>
        <div class="navigation-right"></div>
      </div>
    </div> -->
    <div class="nav-card">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#FFFFFF"
        text-color="#333"
        active-text-color="#D20E0E"
        @select="handleSelect"
      >
        <el-menu-item index="0"
          ><router-link to="/">车架号查询</router-link></el-menu-item
        >
        <el-menu-item index="1">零件号查询</el-menu-item>
      </el-menu>
    </div>
    <div class="top-search-oe">
      <el-row>
        <el-col :span="2">
          <span class="oe-label">OE查询</span>
        </el-col>
        <el-col :span="8">
          <div class="oe-navigation-cont bg-purple-light">
            <el-input
              placeholder="请输入OE编码"
              v-model="oeCode"
              @focus="inputFocus"
              @keyup.enter.native="enterSearch($event)"
              class="oe-input"
              clearable
            >
              <!-- suffix-icon="el-icon-search"-->
              <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
              <!-- <i class="el-icon-search"></i> -->
            </el-input>
            <div
              class="oe-bdsug oe-bdsugbg"
              id="bdsugbg"
              v-show="oeRecordShow && oeRecordList && oeRecordList.length > 0"
            >
              <i
                class="el-icon-circle-close close-record-btn"
                @click="closeRecord"
              ></i>
              <ul>
                <li
                  v-for="(item, index) in oeRecordList"
                  :key="index"
                  @click="selectRecordItem(item)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="4"
          ><el-button class="oe-search-btn" type="default" @click="searchOe"
            >查询</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div class="main-content">
      <div class="top-type">
        <div class="select-brand-area" v-if="brandTags && brandTags.length > 0">
          <span class="">选中品牌：</span>
          <el-tag
            v-for="tag in brandTags"
            :key="tag.brandCName"
            closable
            class="sign-tag"
            @close="handleClose(tag)"
            type="danger"
          >
            {{ tag.brandCName }}
          </el-tag>
        </div>
        <div v-if="!isShowAllBrand">
          <span class="top-label">品牌筛选：</span>
          <span
            :class="[brandIndex[0] ? 'active' : '', 'all-type']"
            @click="changeBrand(0, 1, 0)"
            >全部</span
          >
          <div class="top-type-list">
            <ul>
              <li
                v-for="(brand, bIndex) in brandTypeList"
                :class="[brandIndex[bIndex * 1 + 1] ? 'active' : '']"
                @click="changeBrand(bIndex, 1, 1)"
              >
                {{ brand.brandCName }}
              </li>
            </ul>
          </div>
          <el-button
            type="default"
            class="skan-all-brand-btn"
            size="mini"
            @click="showAllBrand"
            >查看全部</el-button
          >
        </div>
        <div class="show-all-brand" v-show="isShowAllBrand">
          <span class="top-label">品牌筛选：</span>
          <span
            :class="[brandIndex[0] ? 'active' : '', 'all-type']"
            @click="changeBrand(0, 1, 0)"
            >全部</span
          >
          <ul class="top-type-list">
            <li
              v-for="(brand, cIndex) in allBrandTypeList"
              :class="[brandIndex[cIndex * 1 + 1] ? 'active' : '']"
              @click="changeBrand(cIndex, 1, 1)"
            >
              {{ brand.brandCName }}
            </li>
          </ul>
          <i
            class="el-icon-circle-close close-btn"
            @click="closeFolatFixed"
          ></i>
        </div>
      </div>
      <div class="top-type">
        <span class="top-label">品类筛选：</span>
        <span
          :class="[catalogIndex == 0 ? 'active' : '', 'all-type']"
          @click="changeBrand(0, 2, 0)"
          >全部</span
        >
        <div class="top-type-list">
          <ul>
            <li
              v-for="(cata, nIndex) in catalogList"
              :class="[catalogIndex == nIndex * 1 + 1 ? 'active' : '']"
              @click="changeBrand(nIndex, 2, 1)"
            >
              {{ cata.categoryName }}
            </li>
          </ul>
        </div>
        <div class="catetory-list" v-show="childCateShow">
          <ul>
            <li
              v-for="(child, hIndex) in childCatetoryData"
              :class="[childCatalogIndex == hIndex * 1 ? 'active' : '']"
              @click="changeChildCategory(child, hIndex)"
            >
              {{ child.categoryName }}
            </li>
          </ul>
        </div>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="oeImage" label="图片" width="180">
            <template slot-scope="scope">
              <div class="brand-img">
                <img
                  v-if="scope.row.oeImage && scope.row.oeImage.length > 0"
                  :src="scope.row.oeImage[0]"
                  alt="图片"
                />
                <div v-else>暂无图片</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="oe" label="品牌编号" width="180">
            <template slot-scope="scope">
              <div class="brand-name">
                <router-link
                  :to="{
                    path: '/oeSearchDetail',
                    query: { rowData: JSON.stringify(scope.row) }
                  }"
                  class="return-benben"
                >
                  <span>{{ scope.row.oe }}</span>
                </router-link>
                <i
                  class="el-icon-document-copy copy-icon"
                  @click="copyPartsNo(scope.row.oe)"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="oeCName" label="零件名称"> </el-table-column>
          <el-table-column prop="brandLogo" label="品牌" width="180">
            <template slot-scope="scope">
              <div class="brand-img">
                <img
                  v-if="scope.row.brandLogo"
                  :src="scope.row.brandLogo"
                  alt="图片"
                />
                <div v-else>暂无图片</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="typeId" label="型号"> </el-table-column>
          <el-table-column prop="remark" label="注释"> </el-table-column>
          <el-table-column prop="price" label="参考价格">
            <template slot-scope="scope">
              <div v-if="scope.row.price">¥&nbsp;{{ scope.row.price }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="t-page">
        <el-pagination
          small
          layout="prev, pager, next, jumper"
          :current-page.sync="listQuery.page"
          :page-size="listQuery.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="listQuery.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { findOeList, findBrand, findCategory } from "@/api/service/oeApi.js";
export default {
  data() {
    return {
      vin: "",
      recordShow: false,
      isShowAllBrand: false,
      childCateShow: false,
      tableData: [],
      modelCname: "",
      /** 配件列表数据详情 */
      partList: [],
      shortVinBrandList: [],
      activeTagIndex: 0,
      brandCode: "",
      vinTips: "请输入17位VIN码",
      allBrandTypeList: [],
      brandTypeList: [],
      allCatalogList: [],
      catalogList: [],
      brandIndex: [true],
      allBrandIndex: 0,
      catalogIndex: 0,
      childCatalogIndex: 0,
      activeIndex: "1",
      oeCode: "",
      oeRecordShow: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        total: 0,
        qt: "",
        brandSupplierId: "",
        categoryOneId: "",
        categoryTwoId: ""
      },
      childCatetoryData: [],
      allTableData: [],
      brandTags: []
    };
  },
  created() {
    // this.findOeList();
    this.findArticleBrand();
    this.findCategory();
  },
  computed: {
    oeRecordList() {
      let vinList = localStorage.getItem("oeRecord")
        ? JSON.parse(localStorage.getItem("oeRecord"))
        : [];
      // vinList.slice(8);
      return vinList;
    }
  },
  methods: {
    findOeList() {
      this.oeRecordShow = false;
      let arr = this.brandTags;
      let brandIds = [];
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          brandIds.push(item.id);
        });
      }
      this.listQuery.brandSupplierId = brandIds.join(",");
      findOeList({
        oe: this.oeCode,
        brandIds: this.listQuery.brandSupplierId,
        categoryOneId: this.listQuery.categoryOneId,
        categoryTwoId: this.listQuery.categoryTwoId,
        page: this.listQuery.page,
        qt: this.listQuery.qt
      }).then(res => {
        if (res.data.status === "0") {
          let data = res.data.data;
          data.forEach(item => {
            item.oeImage = item.oeImage ? item.oeImage.split(",") : [];
          });
          this.tableData = data ? data : [];
          this.allTableData = data ? data : [];
          // this.listQuery.qt = res.data.qt;
          // this.listQuery.total = data.total;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    enterSearch(e) {
      this.findOeList();
    },
    findArticleBrand() {
      findBrand({}).then(res => {
        if (res.data.status === "0") {
          let data = res.data.data;
          this.allBrandTypeList = data;
          this.brandIndex = [true];
          data.forEach(item => {
            this.brandIndex.push(false);
          });
          let arr = JSON.parse(JSON.stringify(data));
          this.brandTypeList = arr.splice(0, 15);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    findCategory() {
      findCategory().then(res => {
        if (res.data.status === "0") {
          let data = res.data.data ? res.data.data : [];
          let newArr = [];
          data.forEach(item => {
            if (item.pId * 1 === 0) {
              newArr.push(item);
            }
          });
          if (newArr && newArr.length > 0) {
            newArr.forEach(key => {
              key.childList = [];
              data.forEach(parent => {
                if (parent.pId * 1 === key.id * 1) {
                  key.childList.push(parent);
                }
              });
            });
          }
          this.allCatalogList = newArr;
          this.catalogList = newArr;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closeFolatFixed() {
      this.isShowAllBrand = false;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(tag) {
      let brandArr = this.allBrandTypeList;
      let cIndex = null;
      brandArr.forEach((item, index) => {
        if (item.id === tag.id) {
          cIndex = index;
          this.brandIndex[index * 1 + 1] = false;
        }
      });
      this.brandTags.splice(this.brandTags.indexOf(tag), 1);
      if (this.brandTags.length <= 0) {
        this.brandIndex[0] = true;
      }
      this.findOeList();
    },
    showAllBrand() {
      this.isShowAllBrand = true;
    },
    selectRecordItem(vin) {
      // this.oeCode = vin;
      this.$set(this, "oeCode", vin);
      this.findOeList();
      this.oeRecordShow = false;
    },
    carInfoDialog() {
      this.$refs.carConfigInfo.carInfoVisible = true;
    },

    /** 打开选择车型弹窗 */
    carTypeDialog() {
      this.$refs.chooseCarType.dialogVisible = true;
    },
    // 返回犇犇
    returnBenBen() {
      //window.open("https://www.apbenben.com", "_blank");
    },
    changeBrand(index, type, value) {
      if (type === 1) {
        // 品牌
        // this.brandIndex = value === 0 ? value : index * 1 + 1;
        this.brandIndex[index * 1 + 1] = value !== 0 ? true : false;
        if (value !== 0) {
          this.brandIndex[0] = false;
          if (this.brandTags.indexOf(this.allBrandTypeList[index]) === -1) {
            this.brandTags.push(this.allBrandTypeList[index]);
            this.findOeList(index, type);
          }
        } else {
          // this.findOeList();
          this.listQuery.brandSupplierId = "";
          this.tableData = this.allTableData;
          this.findOeList();
        }
      } else {
        // 品类
        this.catalogIndex = value === 0 ? value : index * 1 + 1;
        this.childCatetoryData = this.catalogList[index * 1].childList;
        if (value !== 0) {
          this.childCateShow = true;
          this.childCatalogIndex = 0;
          this.listQuery.categoryOneId = this.catalogList[index].id;
          this.listQuery.categoryTwoId =
            this.catalogList[index].childList.length > 0
              ? this.catalogList[index].childList[0].id
              : "";
          this.findOeList();
        } else {
          this.listQuery.categoryOneId = "";
          this.listQuery.categoryTwoId = "";
          this.childCateShow = false;
          this.childCatalogIndex = 0;
          this.findOeList();
        }
      }
    },
    changeChildCategory(data, index) {
      this.childCatalogIndex = index;
      this.listQuery.categoryTwoId = data.categoryId;
      this.findOeList(index, 2);
    },
    closeRecord() {
      this.oeRecordShow = false;
    },
    filterOeList(index, type) {
      let arr = this.tableData;
      let obj = this.brandTypeList[index];
      let newArr = [];
      arr.forEach(item => {
        if (item.manufacturerCname === obj.brandCName) {
          newArr.push(item);
        }
      });
      this.tableData = newArr;
      this.listQuery.total = newArr.length;
    },
    inputFocus() {
      this.oeRecordShow = true;
    },
    searchOe() {
      this.oeRecordShow = false;
      let arr = [];
      arr = localStorage.getItem("oeRecord")
        ? JSON.parse(localStorage.getItem("oeRecord"))
        : [];
      let flag = false;
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          if (arr.indexOf(this.oeCode) !== -1) {
            flag = true;
          }
        });
      }
      if (!flag) {
        arr.push(this.oeCode);
      }
      // this.oeList = arr
      let resultArr = arr.length > 8 ? arr.slice(-8) : arr;
      localStorage.setItem("oeRecord", JSON.stringify(resultArr));
      this.findOeList();
    },
    handleSizeChange(val) {
      this.$set(this.listQuery, "page", 1);
      this.$set(this.listQuery, "pageSize", val);
      this.findOeList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.findOeList();
    },
    /** 复制编码 */
    copyPartsNo(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    /** 搜索vin码，获取车型信息 */
    vinCodeSearch() {
      if (!this.vin) {
        this.$message.warning("VIN 码不能为空");
        this.prompt = true;
        return;
      }
      let vinLength = this.shortVinBrandList[this.activeTagIndex].length;
      if (this.vin.length !== vinLength) {
        this.$message.warning(this.vinTips);
        this.prompt = true;
        return;
      }
      this.axios
        .get("/vtm", { params: { vin: this.vin, brandCode: this.brandCode } })
        .then(response => {
          if (response.status === 200 && response.data.status == 0) {
            if (response.data.data.length == 0) {
              this.$message.error("无法根据VIN码查出配件信息");
              return;
            } else if (response.data.data.length === 1) {
              this.prompt = false;
              this.getAssembly(response.data.data[0].symbol);
              this.modelCname = response.data.data[0].element.modelCname;
            } else {
              this.$refs.chooseModel.dialogVisible = true;
              this.chooseModelList = response.data.data;
            }
            this.setLocalStorage(this.vin);
          } else {
            this.$message.error(response.data.message);
            this.prompt = true;
          }
        });
    }
  }
};
</script>
<style lang="scss">
.is-active {
  background: #ffffff !important;
}
.is-active:hover {
  background: #ffffff !important;
}
.table-list .el-table th {
  background: #f9f9f9;
}
</style>
<style scoped="scoped" lang="scss">
@import "@/custom.scss";
.el-menu-demo {
  a {
    text-decoration: none;
    color: #333333;
    display: block;
  }
}
.is-active a {
  color: rgb(210, 14, 14);
}
.oe-list-warp {
  background: #f5f5f5;
}
.navigation {
  background-color: $white-color;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  .navigation-content {
    width: 1500px;
    height: 100px;
    min-width: $min-width;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .logo-left {
      width: 300px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .return-benben {
      line-height: 49px;
      font-size: 14px;
      color: $main-color;
      text-decoration: none;
      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }
    .navigation-logo {
      width: 197px;
      height: 49px;
      cursor: pointer;
    }

    .navigation-search {
      position: relative;
      width: 520px;
    }
    .bdsug {
      z-index: 100;
      height: auto;
    }
    .bdsugbg {
      position: absolute;
      width: 270px;
      background: #fff;
      border: 1px solid #ccc !important;
      ul li {
        padding: 1px 15px;
        color: #626675;
        line-height: 28px;
      }
      li {
        /* width: 519px; */
        line-height: 25px;
        padding: 0 8px;
        &:hover {
          background-color: rgba(203, 46, 50, 0.1);
          color: $main-color;
          cursor: pointer;
        }
      }
    }

    .navigation-right {
      width: 250px;
      height: 100%;
      background: url(../../assets/img/slogan.png) no-repeat;
      background-position: center center;
    }

    .name-font {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
      color: rgba(51, 51, 51, 1);
      a {
        color: $main-color;
        text-decoration: none;
        font-weight: 800;
        cursor: pointer;
      }
    }

    .search-bar-selection {
      position: absolute;
      font-size: 12px;
      line-height: 24px;
      .vehicle-name {
        color: #999;
        margin-right: 24px;
        display: inline-block;
      }
      a {
        color: $main-color;
        font-weight: 800;
        text-decoration: underline;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
.main-content {
  margin: 15px 20px 20px;
  padding: 20px;
  background: #ffffff;
  font-size: 14px;
  color: #333333;
  .top-type {
    border-bottom: 1px dashed #cccccc;
    margin: 0 0 10px;
    padding: 0 0 10px;
    position: relative;
    span {
      display: inline-block;
    }
    .top-label {
      vertical-align: top;
      display: inline-block;
      padding: 3px 0 0;
    }
    .all-type {
      color: #333333;
      display: inline-block;
      margin: 0 8px 0 15px;
      padding: 3px 0;
      font-size: 12px;
      vertical-align: top;
      &:hover {
        cursor: pointer;
      }
    }
    .active {
      border-bottom: 1px solid #3898fa;
      color: #3898fa;
    }
    .top-type-list {
      display: inline-block;
      width: 88%;
      line-height: 24px;
      font-size: 12px;
      li {
        display: inline-block;
        margin: 0 12px;
        padding: 0 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        border-bottom: 1px solid #ffffff;
        &:hover {
          cursor: pointer;
        }
      }
      .active {
        color: #3898fa;
        border-bottom: 1px solid #3898fa;
      }
    }
  }
}
.table-list {
  margin: 15px 0;
  font-size: 12px;
}
.brand-name {
  a {
    color: #333333;
    text-decoration: none;
  }
}
.copy-icon {
  display: inline-block;
  margin: 0 0 0 5px;
  color: #333333;
  &:hover {
    cursor: pointer;
  }
}
.brand-img {
  img {
    width: 100px;
  }
}
.nav-card {
  padding: 0 20px;
  font-size: 15px;
  background: #fff;
  margin: 5px 0;
}
.top-search-oe {
  background: #ffffff;
  margin: 0 20px 10px;
  padding: 10px 0;
}
.oe-input {
  width: 350px;
}
.oe-label {
  display: inline-block;
  margin: 10px 10px 10px 20px;
  color: #d20e0e;
  font-weight: bold;
  font-family: "Microsoft YaHei";
}
.oe-search-btn {
  background: #d20e0e;
  color: #ffffff;
}
.oe-navigation-cont {
  position: relative;
}
.oe-bdsug {
  z-index: 100;
  height: auto;
}
.oe-bdsugbg {
  position: absolute;
  width: 348px;
  background: #fff;
  border: 1px solid #ccc !important;
  ul li {
    padding: 1px 15px;
    color: #626675;
    line-height: 28px;
  }
  li {
    /* width: 519px; */
    line-height: 25px;
    margin: 0 10px;
    padding: 0 4px;
    &:hover {
      background-color: rgba(203, 46, 50, 0.1);
      color: $main-color;
      cursor: pointer;
    }
  }
}
.t-page {
  text-align: right;
  padding: 10px 0;
}
.show-all-brand {
  /* position: absolute;
  top: 0;
  left: 0; */
  width: 100%;
  background: #ffffff;
  z-index: 10;
  .top-label {
    vertical-align: top;
    display: inline-block;
    padding: 3px 0 0;
  }
  .all-type {
    color: #333333;
    display: inline-block;
    margin: 0 8px 0 15px;
    padding: 3px 0;
    font-size: 12px;
    vertical-align: top;
    &:hover {
      cursor: pointer;
    }
  }
  .active {
    border-bottom: 1px solid #3898fa;
    color: #3898fa;
  }
  .top-type-list {
    display: inline-block;
    width: 85%;
    line-height: 24px;
    font-size: 12px;
    li {
      display: inline-block;
      margin: 0 12px;
      padding: 0 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      border-bottom: 1px solid #ffffff;
      &:hover {
        cursor: pointer;
      }
    }
    .active {
      color: #3898fa;
      border-bottom: 1px solid #3898fa;
    }
  }
}
.skan-all-brand-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.close-btn {
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 20px;
  &:hover {
    cursor: pointer;
  }
}
.catetory-list {
  font-size: 12px;
  padding: 10px 0 10px 72px;
  li {
    display: inline-block;
    margin: 0 12px;
    padding: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
  }
  .active {
    color: #3898fa;
    border-bottom: 1px solid #3898fa;
  }
}
.close-record-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  &:hover {
    cursor: pointer;
  }
}
.sign-tag {
  display: inline-block;
  margin: 4px 8px;
}
</style>
